import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

interface UseListTableStylesProps {
  hasRows?: boolean;
  isTouchDevice?: boolean;
}

export const useListTableStyles = makeStyles<Theme, UseListTableStylesProps>((theme) => ({
  backdrop: {
    position: 'absolute',
    opacity: '0.5 !important',
    zIndex: 1,
    display: 'flex',
    alignItems: 'flex-start',
    backgroundColor: '#fff !important'
  },
  loadingIndicatorContainer: {
    height: '100%',
    maxHeight: '350px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  tableWrapper: {
    marginBottom: '50px',
    position: 'relative',
    minHeight: (props) => (props.hasRows === false ? '350px' : 0)
  },
  tableHeader: {
    padding: '16px 32px 0 32px',
    [theme.breakpoints.down('sm')]: {
      padding: '8px 16px 0 16px'
    }
  },
  tableTitle: {
    fontWeight: 450
  },
  table: {
    width: '100%',
    '& td:first-child': {
      paddingLeft: '16px',
      [theme.breakpoints.down('sm')]: {
        paddingLeft: '8px'
      }
    },
    '& td:last-child': {
      paddingRight: '16px',
      [theme.breakpoints.down('sm')]: {
        paddingRight: '8px'
      }
    },
    '& th:first-child': {
      paddingLeft: '24px',
      [theme.breakpoints.down('sm')]: {
        paddingLeft: '16px'
      }
    },
    '& tbody > tr:hover': {
      backgroundColor: (props) => (props.isTouchDevice ? theme.palette.background.paper : '#F5F5F5')
    }
  },
  header: {
    color: '#979797',
    padding: '16px 8px'
  },
  placeholderMessage: {
    position: 'absolute',
    top: '50%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    fontSize: '1.2rem'
  },
  tableCell: {
    padding: 0
  },
  colGroupRow: {
    display: 'block',
    margin: '5px 0'
  },
  tableFont: {
    fontSize: '14px'
  },
  tableHeaderFont: {
    fontSize: '12px'
  },
  '@global': {
    'tbody > tr:last-child > td': {
      borderBottom: 0
    }
  },
  tableCellContent: {
    display: 'block',
    width: '100%',
    padding: '8px'
  },
  tableSortLabel: {
    color: 'red'
  }
}));

export const useTooltipStyles = makeStyles({
  tooltip: {
    backgroundColor: '#e6e7e8',
    color: 'black',
    fontSize: '0.9em'
  },
  arrow: {
    color: '#e6e7e8'
  }
});
